import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/svgs/ArrowCircleRight.svg';
const _hoisted_1 = { class: "engagement-report-kpis" };
const _hoisted_2 = { class: "engagement-report-kpis__first-block" };
const _hoisted_3 = { class: "engagement-report-kpis__first-block-card blocks" };
const _hoisted_4 = { class: "blocks__content" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "blocks__name" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_8 = { class: "blocks__numbers" };
const _hoisted_9 = {
    key: 0,
    class: "blocks__value blocks__value--blue cursor"
};
const _hoisted_10 = {
    key: 1,
    class: "blocks__value blocks__value--blue"
};
const _hoisted_11 = { class: "engagement-report-kpis__divider" };
const _hoisted_12 = ["alt"];
const _hoisted_13 = { class: "engagement-report-kpis__first-block-card blocks" };
const _hoisted_14 = { class: "blocks__content" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { class: "blocks__name" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_18 = { class: "blocks__numbers" };
const _hoisted_19 = {
    key: 0,
    class: "blocks__value blocks__value--blue"
};
const _hoisted_20 = {
    key: 1,
    class: "blocks__value blocks__value--blue"
};
const _hoisted_21 = { class: "blocks__percent blocks__value--blue" };
const _hoisted_22 = { class: "engagement-report-kpis__divider" };
const _hoisted_23 = ["alt"];
const _hoisted_24 = { class: "engagement-report-kpis__first-block-card blocks" };
const _hoisted_25 = { class: "blocks__content" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { class: "blocks__name" };
const _hoisted_28 = { class: "blocks__name--small-text" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_30 = { class: "blocks__numbers" };
const _hoisted_31 = {
    key: 0,
    class: "blocks__value blocks__value--blue cursor"
};
const _hoisted_32 = {
    key: 1,
    class: "blocks__value"
};
const _hoisted_33 = { class: "engagement-report-kpis__divider" };
const _hoisted_34 = ["alt"];
const _hoisted_35 = { class: "engagement-report-kpis__first-block-card blocks" };
const _hoisted_36 = { class: "blocks__content" };
const _hoisted_37 = { key: 0 };
const _hoisted_38 = { class: "blocks__name" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_40 = { class: "blocks__numbers" };
const _hoisted_41 = {
    key: 0,
    class: "blocks__value blocks__value--blue cursor"
};
const _hoisted_42 = {
    key: 1,
    class: "blocks__value"
};
const _hoisted_43 = { class: "blocks__percent" };
const _hoisted_44 = { class: "engagement-report-kpis__second-block" };
const _hoisted_45 = { class: "engagement-report-kpis__second-block--card blocks" };
const _hoisted_46 = { class: "blocks__content" };
const _hoisted_47 = { key: 0 };
const _hoisted_48 = { class: "blocks__name" };
const _hoisted_49 = { class: "blocks__name--small-text" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_51 = { class: "blocks__numbers" };
const _hoisted_52 = {
    key: 0,
    class: "blocks__value blocks__value--blue cursor"
};
const _hoisted_53 = {
    key: 1,
    class: "blocks__value"
};
const _hoisted_54 = { class: "engagement-report-kpis__divider" };
const _hoisted_55 = ["alt"];
const _hoisted_56 = { class: "engagement-report-kpis__second-block--card" };
const _hoisted_57 = { class: "blocks__content" };
const _hoisted_58 = { key: 0 };
const _hoisted_59 = { class: "blocks__name" };
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_61 = { class: "blocks__numbers" };
const _hoisted_62 = {
    key: 0,
    class: "blocks__value blocks__value--blue cursor"
};
const _hoisted_63 = {
    key: 1,
    class: "blocks__value"
};
const _hoisted_64 = { class: "blocks__percent" };
import { computed } from 'vue';
import { useStore } from 'vuex';
// components
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import { formatDecimal } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Kpis',
    setup(__props) {
        // libs
        const store = useStore();
        // computed
        const kpis = computed(() => store.getters['engagementReport/getKpis']);
        const isLoading = computed(() => store.getters['engagementReport/getIsIndicatorsLoading']);
        const hasError = computed(() => store.getters['engagementReport/getHasIndicatorsError']);
        const isMillion = (value) => value > 999999;
        const replacePeriodsWithCommas = (value) => value?.replace('.', ',');
        const verifyIsMillion = (value) => value > 999999 ? `${Math.floor(value / 1e5) / 10} mi` : formatDecimal(value);
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (!isLoading.value && !hasError.value && kpis.value?.suggestionsAvailable)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 210
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", null, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.suggestionsAvailable?.name) + " ", 1),
                                                    _hoisted_7
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.suggestionsAvailable?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        (isMillion(kpis.value?.suggestionsAvailable?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_9, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.suggestionsAvailable?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.suggestionsAvailable?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(verifyIsMillion(kpis.value?.suggestionsAvailable?.value)), 1))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: _ctx.$t('campaign.engagement-report.icon-arrow-right')
                        }, null, 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            (!isLoading.value && !hasError.value && kpis.value?.suggestionsUsed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 180
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", null, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.suggestionsUsed?.name) + " ", 1),
                                                    _hoisted_17
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.suggestionsUsed?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        (isMillion(kpis.value?.suggestionsUsed?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_19, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.suggestionsUsed?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.suggestionsUsed?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_20, _toDisplayString(verifyIsMillion(kpis.value?.suggestionsUsed?.value)), 1)),
                                        _createElementVNode("strong", _hoisted_21, _toDisplayString(replacePeriodsWithCommas(kpis.value?.suggestionsUsed?.percent)) + "%", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: _ctx.$t('campaign.engagement-report.icon-arrow-right')
                        }, null, 8, _hoisted_23)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            (!isLoading.value && !hasError.value && kpis.value?.talked)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 180
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_28, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.talked?.name) + " ", 1),
                                                    _hoisted_29
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.talked?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                        (isMillion(kpis.value?.talked?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_31, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.talked?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.talked?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_32, _toDisplayString(verifyIsMillion(kpis.value?.talked?.value)), 1))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: _ctx.$t('campaign.engagement-report.icon-arrow-right')
                        }, null, 8, _hoisted_34)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                            (!isLoading.value && !hasError.value && kpis.value?.suggestionsWithOrder)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 200
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", null, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.suggestionsWithOrder?.name) + " ", 1),
                                                    _hoisted_39
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.suggestionsWithOrder?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                        (isMillion(kpis.value?.suggestionsWithOrder?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_41, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.suggestionsWithOrder?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.suggestionsWithOrder?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_42, _toDisplayString(verifyIsMillion(kpis.value?.suggestionsWithOrder?.value)), 1)),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(replacePeriodsWithCommas(kpis.value?.suggestionsWithOrder?.percent)) + "%", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            (!isLoading.value && !hasError.value && kpis.value?.proactiveContacts)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 220
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_49, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.proactiveContacts?.name) + " ", 1),
                                                    _hoisted_50
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.proactiveContacts?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                        (isMillion(kpis.value?.proactiveContacts?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_52, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.proactiveContacts?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.proactiveContacts?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_53, _toDisplayString(verifyIsMillion(kpis.value?.proactiveContacts?.value)), 1))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: _ctx.$t('campaign.engagement-report.icon-arrow-right')
                        }, null, 8, _hoisted_55)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                            (!isLoading.value && !hasError.value && kpis.value?.proactiveWithOrder)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _createVNode(_component_el_popover, {
                                            trigger: "hover",
                                            placement: "top",
                                            width: 200
                                        }, {
                                            reference: _withCtx(() => [
                                                _createElementVNode("p", null, [
                                                    _createTextVNode(_toDisplayString(kpis.value?.proactiveWithOrder?.name) + " ", 1),
                                                    _hoisted_60
                                                ])
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(kpis.value?.proactiveWithOrder?.tooltip), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                        (isMillion(kpis.value?.proactiveWithOrder?.value))
                                            ? _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_62, [
                                                _createTextVNode(_toDisplayString(verifyIsMillion(kpis.value?.proactiveWithOrder?.value)), 1)
                                            ])), [
                                                [
                                                    _directive_tooltip,
                                                    {
                                                        triggers: ['hover'],
                                                        content: _unref(formatDecimal)(kpis.value?.proactiveWithOrder?.value),
                                                        distance: 8,
                                                        html: true,
                                                    },
                                                    void 0,
                                                    { right: true }
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_63, _toDisplayString(verifyIsMillion(kpis.value?.proactiveWithOrder?.value)), 1)),
                                        _createElementVNode("span", _hoisted_64, _toDisplayString(replacePeriodsWithCommas(kpis.value?.proactiveWithOrder?.percent)) + "%", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoading.value)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (hasError.value && !isLoading.value)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: hasError.value
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
